import React from 'react';
import { usePricingFigures, usd } from '../../../hooks/usePricingFigures';
const head = 'text-[11.5px] font-bold uppercase tracking-[0.12em] text-[#c5cdd3] whitespace-nowrap';
interface Props {
  includeLeader: boolean;
  dueAtSigning: number;
}

/** Option B: what's due to start, then what repeats monthly, then hires. */
export function PricingTwoStep({
  includeLeader,
  dueAtSigning
}: Props) {
  const f = usePricingFigures(includeLeader);
  const monthlyLines = [{
    label: 'Monthly service',
    sub: f.monthlyNote,
    value: `${usd(f.monthly)} / mo`
  }, {
    label: 'Placement bonus',
    sub: f.bonusNote,
    value: `${usd(f.bonus)} / rep`,
    accent: true
  }, {
    label: 'Ad spend',
    sub: f.adsNote,
    value: `${usd(f.adSpend)} / mo`,
    muted: true
  }];
  return <div className="grid grid-cols-[1fr_1.7fr_1.15fr] gap-5 items-stretch" data-id="element-875" data-mp="18n1cposneqqt">
      <div className="rounded-lg border border-[#33404a] px-4 py-3.5" data-id="element-876" data-mp="13pjbylosbhtw">
        <div className={head} data-id="element-877" data-mp="zo7ksbq9iojl">To start</div>
        <div className="brief-display mt-2 text-[32px] font-extrabold leading-none text-white" data-id="element-878" data-mp="zqk8z6mm5v53">
          {usd(dueAtSigning)}
        </div>
        <div className="mt-1.5 text-[12.5px] leading-snug text-[#aab4bc]" data-id="element-879" data-mp="r1j22bvd5j13">
          due at signing
        </div>
        <div className="mt-2.5 pt-2.5 border-t border-[#2a353e] text-[12.5px] leading-snug text-[#d7dde2]" data-id="element-880" data-mp="ccwczifxpcwo">
          {f.showImplementation ? <>
              {usd(f.implementation)} implementation
              <span className="text-[#aab4bc]" data-id="element-881" data-mp="1523ix2hpx4ry"> + first month</span>
              {f.promoDeadlineText && <span className="block mt-1 text-[13px] font-bold text-[#6fd6b0]" data-id="element-882" data-mp="19zd8qj90rigb">
                  Promo · {f.promoDeadlineText.toLowerCase()}
                </span>}
            </> : 'First month of service'}
        </div>
      </div>

      <div className="rounded-lg border border-[#33404a] px-4 py-3.5" data-id="element-883" data-mp="3gpjp6v6pr79w">
        <div className={head} data-id="element-884" data-mp="3ksg2q7hecd6z">Every month</div>
        <ul className="mt-2 space-y-2" data-id="element-885" data-mp="3kt9b1cw07ar8">
          {monthlyLines.map(line => <li key={line.label} className="flex items-baseline justify-between gap-3" data-id="element-886" data-mp="1r8o48yqbiphn">
              <div className="min-w-0" data-id="element-887" data-mp="1mbfk4slm0bdr">
                <span className={`text-[14.5px] font-semibold ${line.accent ? 'text-[#6fd6b0]' : line.muted ? 'text-[#c5cdd3]' : 'text-white'}`} data-id="element-888" data-mp="1mcgwr1i9x5xl">
                  {line.label}
                </span>
                <span className="ml-1.5 text-[12px] text-[#8e9aa4]" data-id="element-889" data-mp="18kap63t6s79r">{line.sub}</span>
              </div>
              <span className={`shrink-0 text-[15px] font-bold ${line.accent ? 'text-[#6fd6b0]' : line.muted ? 'text-[#c5cdd3]' : 'text-white'}`} data-id="element-890" data-mp="13ibm6v1czcdc">
                {line.value}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="flex flex-col justify-center pl-1" data-id="element-891" data-mp="2sw716lwvrh5w">
        <div className={head} data-id="element-892" data-mp="2o0rpo0mchxcn">Projected hires / mo</div>
        <div className="brief-display mt-1 text-[52px] font-extrabold leading-none text-[#6fd6b0]" data-id="element-893" data-mp="2wggwo51og8rd">
          {f.hiresLow}–{f.hiresHigh}
        </div>
        <div className="mt-1 text-[12.5px] leading-snug text-[#aab4bc]" data-id="element-894" data-mp="30grbm77g69id">
          {usd(f.costLow)}–{usd(f.costHigh)} all-in per hire, incl. est. bonuses
        </div>
      </div>
    </div>;
}